import { Grid } from '@mui/material';
import { ActionTypes, SelectOption } from '@tassat/ui-definitions';
import { Formik, FormikHelpers, FormikProps } from 'formik';
import React, { FC, Reducer, useReducer } from 'react';

import { validateWalletForm } from './submission';
import { IFormValues, IFormikProps } from './types';
import { WalletFormContents } from './WalletFormContents';
import { emptySelectOption } from '../helpers/constant';
import {
    FieldValidationAction,
    FieldValidationState,
    fieldValidationReducer,
    setInitialState
} from '../helpers/fieldValidationReducer';

const WalletForm: FC<IFormikProps> = (props) => {
    const {
        formProps,
        onClose
    } = props;

    const {
        actionType,
        checkPendingTransactions,
        firmId,
        firm,
        firmWallets,
        submitWalletForm
    } = formProps;

    let initialValues: IFormValues = {} as IFormValues;
    if (actionType === ActionTypes.add) {
        initialValues = {
            AccountName: '',
            LinkedAccount: emptySelectOption,
            ACGMapping: [],
            Email: '',
            Notes: '',
            AccessControl: {
                label: 'No',
                value: false
            },
            IsLiquidityFacility: false,
            IsPrimary: false
        };
    } else if (actionType === ActionTypes.edit) {
        const editWallet = formProps.editWallet.wallet;
        const linkedAccountRecord = formProps.linkedAccountRecord;
        const walletAcgs = [
            {
                label: editWallet.ACGNumber1,
                value: editWallet.ACGId1
            },
            {
                label: editWallet.ACGNumber2,
                value: editWallet.ACGId2
            },
            {
                label: editWallet.ACGNumber3,
                value: editWallet.ACGId3
            }
        ].filter((acg) => acg.label && acg.value);

        initialValues = {
            AccountName: editWallet.AccountName,
            LinkedAccount: {
                label: linkedAccountRecord ? linkedAccountRecord[0].Account : '',
                value: linkedAccountRecord ? linkedAccountRecord[0].AccountId : ''
            },
            // @ts-ignore
            ACGMapping: walletAcgs,
            Email: editWallet.Email,
            Notes: editWallet.Notes,
            AccessControl: {
                label: editWallet.AccessControl ? 'Yes' : 'No',
                value: editWallet.AccessControl
            },
            IsLiquidityFacility: editWallet.IsLiquidityFacility,
            IsPrimary: editWallet.IsPrimary
        };
    }

    const [
        accessControlState,
        dispatchAccessControlAction
    ] = useReducer<Reducer<
        FieldValidationState<SelectOption>,
        FieldValidationAction<SelectOption>
    >>(fieldValidationReducer, setInitialState());
    const [ submitError, setSubmitError ] = React.useState<string>('');

    return (
        <Grid
            container
            direction='column'
            spacing={0}
            wrap='nowrap'
        >
            <Grid
                item
                xs={12}
            >
                <Formik
                    initialValues={initialValues}
                    onSubmit={async (values: IFormValues, formikHelpers: FormikHelpers<IFormValues>) => {
                        const errors = await formikHelpers.validateForm(values);
                        if (errors && Object.keys(errors).length) {
                            return formikHelpers.setErrors(errors);
                        }

                        return submitWalletForm(values, {
                            actionType,
                            firmId,
                            editWallet: actionType === ActionTypes.edit ?
                                formProps.editWallet.wallet
                                : undefined,
                            onClose,
                            setSubmitError
                        });
                    }}
                    validate={(values: IFormValues) => validateWalletForm(values, {
                        accessControlState,
                        actionType,
                        checkPendingTransactions,
                        editWallet: actionType === ActionTypes.edit ?
                            formProps.editWallet
                            : undefined,
                        dispatchAccessControlAction,
                        initialValues,
                        firm,
                        firmWallets
                    })}
                    validateOnBlur={false}
                    validateOnChange
                    validateOnMount
                >
                    {(formContentProps: FormikProps<IFormValues>) => (
                        <WalletFormContents
                            {...formContentProps}
                            formProps={formProps}
                            submitError={submitError}
                        />
                    )}
                </Formik>
            </Grid>
        </Grid>
    );
};

export default WalletForm;